import { useApiClient } from "@albertine/api-client";
import type {
    CatalogItemSearchResult,
    SearchCatalogItemsQuery,
} from "@albertine/types/openapi/lmt";
import classNames from "classnames";
import { useState } from "react";
import Icon from "../Common/Icon";
import PaginatedList from "../Common/list/PaginatedList";
import {
    CATALOG_SEARCH_RESULTS_PAGE_LENGTH,
    catalogSearchResultsQueryKey,
    queryCatalogSearchResultsPage,
} from "./hooks/useCatalogSearchResults";
import SearchResultItem from "./SearchResultItem";

type Props = {
    className?: string;
    defaultSearch: SearchCatalogItemsQuery;
    onResultItemClick: (id: string) => void;
    onResultItemHover: (id: string | undefined) => void;
    highlightedItemId: string | undefined;
    collabsible?: boolean;
};

function CatalogSearchResults(props: Props) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const {
        className,
        defaultSearch,
        onResultItemClick,
        onResultItemHover,
        highlightedItemId,
        collabsible,
    } = props;

    const { apiClient } = useApiClient();

    const renderResultItem = (item: CatalogItemSearchResult) => (
        <SearchResultItem
            key={item.id}
            item={item}
            filters={defaultSearch}
            onClick={(clickedItem) => {
                onResultItemClick(clickedItem.lmtId);
            }}
            onHover={onResultItemHover}
            highlightedItemId={highlightedItemId}
        />
    );

    return (
        <div
            className={classNames("catalog-search-results-container", {
                "catalog-search-results-container--collapsed":
                    collabsible && isCollapsed,
            })}
        >
            <PaginatedList<string, CatalogItemSearchResult>
                className={className}
                pageLength={CATALOG_SEARCH_RESULTS_PAGE_LENGTH}
                queryKey={catalogSearchResultsQueryKey(defaultSearch)}
                queryForItems={(pagingParams) =>
                    queryCatalogSearchResultsPage(
                        apiClient,
                        defaultSearch,
                        pagingParams.size,
                        typeof pagingParams.page === "string"
                            ? pagingParams.page
                            : undefined,
                    )
                }
                renderItem={(item) => renderResultItem(item)}
                renderError={() => <div>Error happened</div>}
            />
            {collabsible && (
                <button
                    className={classNames("catalog-search-results-collapse-button", {
                        "catalog-search-results-collapse-button--collapsed":
                            isCollapsed,
                    })}
                    type="button"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    <Icon.ChevronLeft.Medium.N10 />
                </button>
            )}
        </div>
    );
}

export default CatalogSearchResults;
